module.exports = __webpack_public_path__ + "img/product-left.d2ff4c06.png";